import React from 'react'
import Item from '../item'
import {withList} from '../../../../../components/list'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'


export default withList(props => {
    useStyles(classes)
    const {showings} = props
    return <div className={classes.List}>
        {
            showings?.map((showing, index) => <Item key={index} showing={showing} removeClick position={index+1} />)
        }
    </div>
})